<template>
  <div class="description">
    <div class="container">
      <ul class="list">
        <li class="list__item">
          <ul class="list__dropdown" v-show="langDropdownShown">
            <li
              class="list__dropdown-item"
              v-for="(lang, key) in langs"
              :key="key"
              @click="switchLang(key)"
            >
              {{ lang.name }}
              <span v-if="lang.translator" class="list__desc"
                >({{
                  $t("TRANSLATED_BY", { translator: lang.translator })
                }})</span
              >
            </li>
          </ul>
          <button
            class="list__link list__link_dropdown"
            @click="langDropdownShown = true"
          >
            <img class="list__icon"
              :src="require(`@/assets/themes/${BRAND_KEY}/images/icon-globe.svg`)" />
            {{ lang.name }}
            <span v-if="lang.translator" class="list__desc"
              >({{
                $t("TRANSLATED_BY", { translator: lang.translator })
              }})</span
            >
          </button>
        </li>
        <li class="list__item">
          <a
            href="https://translate.appdb.to/"
            target="_blank"
            class="list__link"
          >
            {{ $t("HELP_TO_TRANSLATE") }}
          </a>
        </li>
        <li class="list__item" v-if="BRAND_CONFIG.twitter">
          <a
            :href="BRAND_CONFIG.twitter"
            target="_blank"
            class="list__link"
          >
            <img class="list__icon" src="@/assets/icon-twitter.svg" />
            {{ BRAND_CONFIG.twitterName }}
          </a>
        </li>
        <li class="list__item" v-if="BRAND_CONFIG.reddit">
          <a
            :href="BRAND_CONFIG.reddit"
            target="_blank"
            class="list__link"
          >
            <img class="list__icon" width="13" src="@/assets/icon-reddit.svg" />
            {{ BRAND_CONFIG.redditName }}
          </a>
        </li>
        <li class="list__item" v-if="BRAND_CONFIG.telegramGroup">
          <a
            :href="BRAND_CONFIG.telegramGroup"
            target="_blank"
            class="list__link"
          >
            <img class="list__icon" width="13" src="@/assets/icon-telegram.svg" />
            {{ BRAND_CONFIG.telegramGroupName }}
          </a>
        </li>
        <li class="list__item" v-if="BRAND_CONFIG.telegramBot">
          <a
            :href="BRAND_CONFIG.telegramBot"
            target="_blank"
            class="list__link"
          >
            <img class="list__icon" width="13" src="@/assets/icon-telegram.svg" />
            {{ BRAND_CONFIG.telegramBotName }}
          </a>
        </li>
      </ul>
      <p class="text">
        © {{ BRAND_CONFIG.fromYear ? (BRAND_CONFIG.fromYear + '-')
        : '' }}{{ new Date().getFullYear() }}
        {{ BRAND_CONFIG.name }}.
        {{ $t("DO_NOT_HOST_NOTICE") }}.
        <span
          v-html="
            $t('ITUNES_API_NOTICE', {
              documentationLink:
                'https://developer.apple.com/library/archive/documentation/AudioVideo/Conceptual/iTuneSearchAPI/index.html#//apple_ref/doc/uid/TP40017632-CH3-SW1',
            })
          "
        ></span>
        <span v-if="BRAND_KEY !== 'appdb'">. {{ $t('POWERED_BY_APPDB') }}</span>
      </p>
      <p
        class="text"
        v-if="BRAND_CONFIG.email"
        v-html="
          $t('VERSION_AND_COPYRIGHT_VIOLATION', {
            version: $store.getters.appVersion,
            mailLink: `mailto:${BRAND_CONFIG.email}?subject=DMCA`,
          })
        "
      ></p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      langDropdownShown: false,
      langs: [],
    };
  },
  computed: {
    lang() {
      return this.langs[this.$store.getters.lang] || {};
    },
    langsList() {
      return this.langs.filter(lang => lang !== this.lang);
    },
  },
  methods: {
    getLangs() {
      return this.$api.getLanguages().then((data) => {
        this.langs = data;
      });
    },
    switchLang(lang) {
      this.$store.dispatch('setLang', lang);
    },
  },
  serverPrefetch() {
    return this.getLangs();
  },
  mounted() {
    this.getLangs();

    document.body.addEventListener('click', (e) => {
      if (e.path.some(el => typeof el.className === 'string' && el.className.split(' ').includes('list__link_dropdown'))) {
        return;
      }

      this.langDropdownShown = false;
    });
  },
};
</script>

<style lang="scss" scoped>
.description {
  background-color: var(--footer-top-bg);
  padding: 15px 0;
}

.list {
  display: flex;
  align-items: stretch;
  justify-content: center;
  flex-wrap: wrap;

  &__dropdown {
    position: absolute;
    bottom: calc(100% + 5px);
    background-color: $footer-top-bg;
    color: $footer-link-color;
    border: 1px solid $footer-button-border-color;
    border-radius: 3px;
    min-width: 230px;
    z-index: 5;

    &-item {
      padding: 5px;
      font-size: 12px;
      cursor: pointer;

      &:not(:last-child) {
        border-bottom: 1px solid $footer-button-border-color;
      }
    }
  }

  &__item {
    position: relative;
    margin-bottom: 4px;

    &:not(:last-child) {
      margin-right: 4px;
    }
  }

  &__link {
    height: 100%;
    display: flex;
    align-items: center;
    padding: 5px;
    border: 1px solid $footer-button-border-color;
    border-radius: 3px;
    color: $footer-link-color;
    font-size: 12px;
    font-weight: 500;
  }

  &__icon {
    margin-right: 4px;
  }

  &__desc {
    font-size: 10px;
    font-weight: 400;
    color: $footer-text-color;
    margin-left: 3px;
  }
}

.text {
  color: $footer-text-color;
  font-size: 12px;
  text-align: center;
  margin-top: 5px;
  line-height: 18px;

  &:not(:last-child) {
    margin-top: 10px;
  }
}

.link,
.text::v-deep a {
  color: $footer-link-color;
  font-size: 12px;
  font-weight: 500;
}
</style>
